import { createReducer, on } from '@ngrx/store';
import * as StartDestinationActions from '../actions/start-destination.actions';
import {Destination} from '../../../services/api/destinations/destination.model';

export const startDestinationFeatureKey = 'startDestination';

export interface State {
  record: Destination | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(StartDestinationActions.startDestination, (state) => ({
    ...state,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(StartDestinationActions.startDestinationSuccess, (state, action) => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(StartDestinationActions.startDestinationFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(StartDestinationActions.clearStartDestinationState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

